import { useLayoutEffect, useState } from 'react'

export function useBodyScrollLock (initialState) {
  const [scrollLocked, setScrollLocked] = useState(initialState)
  const [originalOverflow, setOriginalOverflow] = useState(null)

  useLayoutEffect(() => {
    setOriginalOverflow(window.getComputedStyle(document.body).overflow)
    return () => { document.body.style.overflow = originalOverflow || 'visible' }
  }, [])

  useLayoutEffect(() => {
    document.body.style.overflow = scrollLocked ? 'hidden' : originalOverflow
  }, [scrollLocked])

  return [setScrollLocked]
}